// utils/markISTCaptured.js
export function markISTCaptured(session, moduleID, subType, index) {
  const key = `camera:ist:${moduleID}:${subType}`
  const updated = {
    ...session,
    captured: [...session.captured, index],
  }
  localStorage.setItem(key, JSON.stringify(updated))
}
